import { useParams, useNavigate } from '@tanstack/react-router';
import Loader from '@zeus/core/Loader';
import { useOrganization } from '_/contexts/OrganizationContext';
import { useDestination, useUpdateDestination } from '_/hooks/useDestinations';
import React, { ReactElement, useEffect } from 'react';

import DestinationFormPage from './DestinationFormPage';

const EditDestination = (): ReactElement => {
  const history = useNavigate();
  const params = useParams({ strict: false }) as Partial<Record<string, string>>;
  const { destinationId } = params;
  const { selectedOrgSlug } = useOrganization();
  const { data: selectedDestination, isLoading } = useDestination(destinationId);
  const { mutate: updateDestinationMutation, isPending: isUpdating } = useUpdateDestination(selectedOrgSlug || '');

  // Redirect to destinations list if destination not found after loading
  useEffect(() => {
    if (!isLoading && !selectedDestination) {
      void history({ to: `/orgs/${selectedOrgSlug}/destinations` });
    }
  }, [isLoading, selectedDestination, history, selectedOrgSlug]);

  if (isLoading) {
    return <Loader />;
  }

  if (!selectedDestination) {
    return null; // Will redirect via useEffect
  }

  const handleSubmit = (destination: any) => {
    updateDestinationMutation({ destinationId: selectedDestination.id, destination: destination });
  };

  return <DestinationFormPage mode="edit" destination={selectedDestination} onSubmit={handleSubmit} isSubmitting={isUpdating} />;
};

export default EditDestination;
